import Konva from "konva";
import Helper from "../Helper";
import Webfont from "../WebFont";
import Translation from "../Translation";
import  ErrorManager from "../ErrorManager";


class _Text extends Konva.Text{
    constructor(config, textJSON){        
        super(config);
        this.className = 'Text';
        this.textureObj = undefined;
        this.fontLoaded = false;
        this._textJSON = textJSON;
    }

    _sceneFunc(ctx){   
        this.fillAfterStrokeEnabled(true);
     
        if(this.getAttr('name') === 'content'){
            if(this.fontLoaded === true){
                ctx.save();
                super._sceneFunc(ctx);
                
                if(this.textureObj && this.isTextureEnabled()){
                    let group_pos = this.getParent().position();
                    let frame_pos = this.position();
                    ctx.rotate((this.rotation() * -1 ) * Math.PI / 180);
                    ctx.globalCompositeOperation = 'source-in';
                    let x = (group_pos.x + frame_pos.x) * -1;
                    let y = (group_pos.y + frame_pos.y) * -1;

                    let rotate = this.getAttr('rotate_texture');
                    let summaryRotation = 0, z;
                    if(rotate){
                        switch(rotate){
                            case 270:
                                summaryRotation = (rotate) * Math.PI / 180;
                                z = x;
                                x = y - 1000 + ((group_pos.y + frame_pos.y)*2);
                                y = z;
                                ctx.rotate(summaryRotation);
                                break;
                            case 90:
                                summaryRotation = (rotate) * Math.PI / 180;
                                z = x - 1000 + ((group_pos.x + frame_pos.x) * 2);
                                x = y;
                                y = z;
                                ctx.rotate(summaryRotation);
                        }
                    }
                    ctx.drawImage(this.textureObj, 0, 0, 1000, 1000, x, y, 1000, 1000);
                    
                }
                ctx.restore();

                if(this.getAttr('innerShadowEnabled')){
                    let group_pos = this.getParent().position();
                    let frame_pos = this.position();
                    ctx.rotate((this.rotation() * -1 )* Math.PI / 180);
                    let copy_canvas = document.createElement('canvas');
                    let copy_ctx = copy_canvas.getContext('2d');
                    copy_canvas.width = ctx._context.canvas.width;
                    copy_canvas.height = ctx._context.canvas.height;
                    
                    copy_ctx.drawImage(ctx._context.canvas, 0, 0);
                    
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.shadowBlur = 0; 
                    ctx.shadowOffsetX = 0.5;
                    ctx.shadowOffsetY = 0.5;
                    ctx.shadowColor = 'black';
                    ctx.drawImage(copy_canvas, 0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  
                    ctx.shadowBlur = 0; 
                    ctx.shadowOffsetX = -0.5;
                    ctx.shadowOffsetY = -0.5;
                    ctx.shadowColor = 'black';
                    ctx.drawImage(copy_canvas, 0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  


                    ctx.fillStyle = 'black';
                    ctx.shadowColor="transparent"; 
                    ctx.globalCompositeOperation = "xor";
                    ctx.fillRect((group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000);
                    
                    ctx.shadowBlur = this.getAttr('innerShadowBlur');
                    ctx.shadowOffsetX = this.getAttr('innerShadowOffsetX'); 
                    ctx.shadowOffsetY = this.getAttr('innerShadowOffsetY'); 

                    let rgb = Helper.hexToRgb(this.getAttr('innerShadowColor'));
                    ctx.shadowColor = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + this.getAttr('innerShadowOpacity') + ')';
        
                    ctx.drawImage(ctx._context.canvas, 0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  
            
                    ctx.globalCompositeOperation = "destination-atop";
                    ctx.shadowColor = "transparent";         // remove shadow !
                    ctx.drawImage(copy_canvas, 0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );
                }
            }
        }
    }

    isTextureEnabled(){
        let textureEnabled = this.getAttr('texture_enabled');
        return ( !textureEnabled || ( textureEnabled && textureEnabled === true)) ? true : false;
    }

    load(_resolve, _reject){
        new Promise((resolve, reject) => {
            this.loadFont(resolve, reject);
        }).then(resolveValue => {
            this.fontLoaded = true;
            let textTemp = this._getTextJSONText(
                Translation.getSelectedLanguage()
            );
            this.setText('');
            this.setText(textTemp);

            if(this.isTextureEnabled())
                new Promise((resolve, reject) => {
                    this.loadTexture(resolve, reject);
                }).then(resolveValue => {
                    this.textureObj = resolveValue;
                    _resolve("OK");
                }).catch(err => _reject(err))
            else
                _resolve("OK");
        });
        
    }

    loadTexture(resolve, reject){
        if(!this.textureObj && this.getAttr('texture_src')){
            let img = Helper.loadImage(
                this.getAttr('texture_src'),
                () => {
                    resolve(img);
                },
                (err) => {
                    reject(err);
                }
            );
        }else{
            resolve();
        }
    }

    loadFont(resolve, reject){
        Webfont.loadFont({
                familyName: this.getAttr('fontFamily'),
                fontSize: this.getAttr('fontSize')
            },
            resolve, reject);
    }

    _setTextJSON(value, lang){
        this.attrs.textJSON[lang].text = value;
        this.setText(value);
        return this.fitText(lang);
    }

    _getTextJSONText(lang, scriptLabel = null){
        this.setTextJSONIfNotExist(lang);
        this.fitText(lang, scriptLabel);
        return this.textJSON()[lang].text;
    }

    _getTextJSONLabel(lang){
        this.setTextJSONIfNotExist(lang);
        return this.textJSON()[lang].label && this.textJSON()[lang].label != "" ? this.textJSON()[lang].label : Translation.getTranslation('defaultInputLabel');
    }

    setTextJSONIfNotExist(lang){
        let textjson = this.textJSON();
        if(Object.keys(this.textJSON()).length === 0){
            textjson = this._textJSON.getObjectCopy();
            textjson.pl.text = this.getText().trim();
            textjson.pl.attributes.sentence = this.sentence();
            textjson.pl.attributes.author = this.sentence_author();
            this.textJSON(textjson);
        }

        if(typeof textjson[lang] === "undefined"){
            textjson[lang] = this._textJSON.getLangOptionsObjectCopy();
            this.textJSON(textjson);
        }
    }

    fitText(lang, scriptLabel = null){
        let frame = this.getLayer().findOne(".frame");
        let warning = false;
        let new_font_size = 0;
        let new_font_size_for_catch_warning = 0;
        if(this.text()){
            if(!this.getAttr("minFontSize") || !this.getAttr("maxFontSize")){
                this.setAttr("minFontSize", this.getFontSize());
                this.setAttr("maxFontSize", this.getFontSize());
            }
        }

        if(this.textJSON()[lang].attributes.sentence){
            if(this.getAttr("minFontSize") == this.getAttr("maxFontSize")){
                this.setAttr("minFontSize", Math.round(Number(this.getAttr("maxFontSize")/1.5)));
            }
            this.verticalAlign("center");
        }
        
        let cloned_content = this.clone({width: '2000', name: 'cloned_content'});
        let cloned_content_for_catch_warning = this.clone({width: '2000', name: 'cloned_content_for_catch_warning'});
        
        cloned_content.fontSize(this.getAttr("maxFontSize"));
        new_font_size = this.getAttr("maxFontSize");
        new_font_size = this.calculateWidth(cloned_content, frame, Helper.isFulledit(), scriptLabel);
        cloned_content.width(frame.width());
        cloned_content.height(2000);
        cloned_content.fontSize(new_font_size);
        new_font_size = this.calculateHeight(cloned_content, frame, Helper.isFulledit(), scriptLabel);
        
        cloned_content_for_catch_warning.fontSize(this.getAttr("maxFontSize"));
        new_font_size_for_catch_warning = this.getAttr("maxFontSize");
        new_font_size_for_catch_warning = this.calculateWidth(cloned_content_for_catch_warning, frame, false);
        cloned_content_for_catch_warning.width(frame.width());
        cloned_content_for_catch_warning.height(2000);
        cloned_content_for_catch_warning.fontSize(new_font_size_for_catch_warning);
        new_font_size_for_catch_warning = this.calculateHeight(cloned_content_for_catch_warning, frame, false);


        let cloned_text_height = this._getTextHeight(cloned_content_for_catch_warning);
        let height = frame.height();
        let frame_height = frame.height();
        let pos = frame.position();

        if(Number(cloned_text_height) > Number(frame.height())){
            if(cloned_content_for_catch_warning.textArr.length > 1){
                warning = true;
            }else{
                warning = false;
            }
        }else{
            warning = false;

            if(this.verticalAlign() === "center"){
                let text_height = this._getTextHeight(cloned_content);
                let diff = (frame_height - text_height)/2.3;
                pos.y = pos.y + diff;
                height = frame_height - diff;
            }
        }

        if(this.getAttr("maxChars") && Number(this.getAttr("maxChars")) > 0){
            if(this.text().length > Number(this.getAttr("maxChars"))){
                warning = true;
            }else{
                warning = false;
            }
        }

        this.height(height);
        this.position(pos);
        cloned_content.destroy();
        cloned_content_for_catch_warning.destroy();
        this.fontSize(new_font_size);
        return warning;
    }



    calculateWidth(content, frame, fullEdit, scriptLabel = null){    
        let new_font_size = 0;
        while(true){
            let cloned_text_width = content.getTextWidth() + 30;              
            if(frame.width() > 0 && cloned_text_width > frame.width()){
                if(Number(content.fontSize()) >= Number(content.getAttr("minFontSize")) || fullEdit)
                {
                    content.fontSize(content.fontSize()-1);
                }else{
                    new_font_size = content.getAttr("minFontSize");
                    break;
                }
            }else{
                if(frame.width() == 0)
                {
                    if(scriptLabel !== null) {
                        ErrorManager.addError(Translation.getTranslation('error_sizeWidth') + ' = ' + scriptLabel);
                    }
                }
                new_font_size = content.fontSize();
                break;
            }
        } 
        return new_font_size;
    }

    calculateHeight(content, frame, fullEdit, scriptLabel = null){
        let new_font_size = 0;
        while(true){
            let cloned_text_height = this._getTextHeight(content);
            if(Number(frame.height()) > 0 && Number(cloned_text_height) > Number(frame.height())){
                if(Number(content.fontSize()) > Number(content.getAttr("minFontSize")) || fullEdit){                    
                    content.fontSize(content.fontSize() - 1);
                }else{                    
                    new_font_size = content.getAttr("minFontSize");
                    break;
                }
            }else{
                if(frame.height() == 0)
                {   
                    if(scriptLabel !== null) {
                        ErrorManager.addError(Translation.getTranslation('error_sizeHeight') + ' = ' + scriptLabel);
                    } 
                    // ErrorManager.addError(Translation.getTranslation('error_sizeHeight') + textId+ ' = ' + content.getAttr("text"));
                }
                new_font_size = content.fontSize();
                break;
            }
        }
        return new_font_size;
    }

    _getTextHeight(content){
        let height = content.getTextHeight() * content.textArr.length * content.getLineHeight() + content.getPadding() * 2;
       
        //height = height * 1.15; // dodajemy bo konva źle liczy wysokość
        //height = Math.round(height);
       
        return height;
    }
}

Konva._Text = _Text;
